import React, { useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import { buildEventCalendarPath } from "../shared/utils/eventCalendarNavigation";
import TabsList from "./TabsList";

export const VOLUNTEER_TAB_OPPORTUNITIES = "opportunities";
export const VOLUNTEER_TAB_PARTICIPANTS = "participants";
export const VOLUNTEER_TAB_SIGNUP = "signup";
export const VOLUNTEER_TAB_DASHBOARD = "dashboard";

/**
 * Cross-route tabs between Volunteer Opportunities, Volunteer Signup, and Volunteer Impact Dashboard.
 */
export default function VolunteerSectionTabs({ activeTab }) {
  const navigate = useNavigate();
  const { hasPermission, userInfo } = useAuth();
  const showOpportunities = hasPermission && hasPermission("menu.volunteer_opportunities");
  const showSignup = hasPermission && hasPermission("menu.volunteer_signup");
  const showDashboard = hasPermission && hasPermission("menu.volunteer_impact_dashboard");
  const eventCalendarPath = useMemo(
    () => buildEventCalendarPath({ accountId: userInfo?.account_id }),
    [userInfo?.account_id]
  );

  return (
    <TabsList className="section-tabs-list" role="tablist" aria-label="Volunteer sections">
      {showOpportunities ? (
        <>
          <button
            type="button"
            role="tab"
            aria-selected={activeTab === VOLUNTEER_TAB_OPPORTUNITIES}
            className={`tab-btn ${activeTab === VOLUNTEER_TAB_OPPORTUNITIES ? "active" : ""}`}
            onClick={() => {
              if (activeTab !== VOLUNTEER_TAB_OPPORTUNITIES) navigate("/VolunteerOpportunities");
            }}
          >
            Volunteer Opportunities
          </button>
          <button
            type="button"
            role="tab"
            aria-selected={activeTab === VOLUNTEER_TAB_PARTICIPANTS}
            className={`tab-btn ${activeTab === VOLUNTEER_TAB_PARTICIPANTS ? "active" : ""}`}
            onClick={() => {
              if (activeTab !== VOLUNTEER_TAB_PARTICIPANTS) navigate("/VolunteerParticipants");
            }}
          >
            Participants
          </button>
        </>
      ) : null}
      {showSignup ? (
        <button
          type="button"
          role="tab"
          aria-selected={activeTab === VOLUNTEER_TAB_SIGNUP}
          className={`tab-btn ${activeTab === VOLUNTEER_TAB_SIGNUP ? "active" : ""}`}
          onClick={() => {
            if (activeTab !== VOLUNTEER_TAB_SIGNUP) navigate("/VolunteerSignup");
          }}
        >
          Volunteer Signup
        </button>
      ) : null}
      {showDashboard ? (
        <button
          type="button"
          role="tab"
          aria-selected={activeTab === VOLUNTEER_TAB_DASHBOARD}
          className={`tab-btn ${activeTab === VOLUNTEER_TAB_DASHBOARD ? "active" : ""}`}
          onClick={() => {
            if (activeTab !== VOLUNTEER_TAB_DASHBOARD) navigate("/VolunteerImpactDashboard");
          }}
        >
          Volunteer Dashboard
        </button>
      ) : null}
      <button
        type="button"
        className="tab-btn"
        onClick={() => navigate(eventCalendarPath)}
      >
        Event Calendar
      </button>
    </TabsList>
  );
}
